import moment from 'moment'; //Curiosidad

export const getters = {
  getFiltersFromProvisionalRemedyRequest: function(state) {
    return state.FiltersFromProvisionalRemedyRequest;
  },
  getResults: (state) => {
    if (state.results.length == 0) return [];

    const results = state.results.map((element, index) => {
      element.index = index;
      element.ariaExpanded = false;
      element.createDate = moment(element.createDate)
        .locale('es')
        .format('DD/MMM/YYYY h:mm:ss a');
      element.requestDate = element.requestDate
        ? moment(element.requestDate)
            .locale('es')
            .format('DD/MMM/YYYY')
        : null;
      element.preReservationDate = element.preReservationDate
        ? moment(element.preReservationDate)
            .locale('es')
            .format('DD/MMM/YYYY h:mm:ss a')
        : null;
      element.timeStartHours = element.appointment_TimeStart
        ? moment(element.appointment_TimeStart)
            .locale('es')
            .format('h:mm a')
        : null;
      element.timeEndHours = element.appointment_TimeEnd
        ? moment(element.appointment_TimeEnd)
            .locale('es')
            .format('h:mm a')
        : null;
      element.appointment_TimeStart = element.appointment_TimeStart
        ? moment(element.appointment_TimeStart)
            .locale('es')
            .format('DD/MMM/YYYY')
        : null;
      element.requestProvisionalDate = element.requestProvisionalDate
        ? moment(element.requestProvisionalDate)
            .locale('es')
            .format('DD/MMM/YYYY')
        : null;
      element.evaluationDate = element.evaluationDate
        ? moment(element.evaluationDate)
            .locale('es')
            .format('DD/MMM/YYYY')
        : null;
      element.contractEvaluationDate = element.contractEvaluationDate
        ? moment(element.contractEvaluationDate)
            .locale('es')
            .format('DD/MMM/YYYY')
        : null;
      element.showCoordinateAppointment = false;
      return element;
    });
    return results;
  },
  getTableConfig: (state) => {
    return {
      ...state.paging,
      totalRecords: state.paging.totalItemCount,
      currentPage: state.paging.currentPage,
      pageCount: state.paging.pageCount,
      totalPages: state.paging.pageCount,
      pageSize: state.configPaginated.pageSize,
    };
  },
  getCurrentFilters: (state) => {
    return state.model;
  },
};
